<div class="profile-container d-flex flex-wrap align-items-center justify-content-between  mt-2 mb-2">
  <div class="d-flex align-items-center">
    <div class="circle">
      <div
        class="position-relative d-flex justify-content-center align-items-center unelectable bg-white rounded-circle h-100">
        @if (profileForm.get('image').value) {
          <img class="q-image" alt="user image"
            (error)="reloadImage(profileForm.get('image'))"
            [src]="profileForm.get('image').value"/>
        }
        @if (!isDisabled) {
          <div
            (click)="openImageModal({field:profileForm.get('image'), height:270, width:270, imageType:imageType})"
            class="image-icon icon-circle position-absolute d-flex justify-content-center align-items-center cursor-pointer">
            <mat-icon color="primary">camera_alt</mat-icon>
          </div>
          @if (profileForm.get('image').value) {
            <div
              class="trash-icon icon-circle position-absolute d-flex justify-content-center align-items-center cursor-pointer"
              (click)="removeImage()">
              <mat-icon color="primary">delete</mat-icon>
            </div>
          }
        }
        @if (!profileForm.get('image').value) {
          <div
            [style.background-color]="data?.name|nameToColor"
            class="circle-image-box w-100 h-100 d-flex align-items-center justify-content-center position-relative">
            @if (data?.name) {
              <span class="name">{{ (data?.name[0]) | uppercase }}</span>
            }
            <!--            <span *ngIf="!isEdit;else name" class="size">270x270</span>-->
            <ng-template #name>
              @if (data?.name) {
                <span class="name">{{ (data?.name[0]) | uppercase }}</span>
              }
            </ng-template>
          </div>
        }
      </div>
    </div>
    <div class="profile-name">
      <div class="text-truncate">
        <span>{{ data?.name }}</span>
      </div>
      <!--      <div *ngIf="isProfileView" class="fs-14 d-flex align-items-center">-->
      <!--        <mat-icon *ngIf="data.isPrivate;else privateIcon">-->
      <!--          public_off-->
    <!--        </mat-icon>-->
    <!--        <ng-template #privateIcon>-->
    <!--          <mat-icon>-->
    <!--            public-->
  <!--          </mat-icon>-->
<!--        </ng-template>-->
<!--        <div class="ml-2">-->
<!--          Private-->
<!--        </div>-->
<!--      </div>-->
</div>
</div>
</div>
